import { BreadcrumbModel } from '../../models/breadcrumb.model';

export interface BreadcrumbState {
  breadcrumbList: BreadcrumbModel[];
}

export const initialBreadcrumbState: BreadcrumbState = {
    breadcrumbList: [],
};
